import { IonCol, IonContent, IonGrid, IonPage, IonRow, useIonViewDidLeave } from "@ionic/react";
import { useEffect, useState } from "react";
import { useLocation } from "react-router";
import CreditPayV2 from "../../components/CreditPayV2";
import Footer from "../../components/Footer";
import { User } from "../../models/data";

interface CreditProps {
    user: User
}
const DonateOnlineV2: React.FC<CreditProps> = (props) => {
    const location: any = useLocation();
    const [data, setData] = useState<any>();
    useEffect(() => {
        if(location.state){setData(location.state.data)}
    },[location.state]);
   


    return (
        <IonPage className="viewContainer">
            <IonContent>
                <IonGrid>
                    <IonRow>
                        <IonCol>
                            {data && <CreditPayV2 type='donate' donateData={data} amount={data.amount} user={props.user}></CreditPayV2>}
                        </IonCol>
                    </IonRow>
                </IonGrid>
            <Footer></Footer>
            </IonContent>
        </IonPage>
    );

}

export default DonateOnlineV2;